import { usePostHog } from "posthog-js/react";
import type {
  EventPropertiesMap,
  TEventProperties,
} from "@tracking-events/browser";

import type { IUseEvent } from "./useEvent.map";
import { getEventType } from "./useEvent.utils";

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

export const useEvent = (): IUseEvent => {

  const posthog = usePostHog();

  const dispatchPostHogEvent = <N extends keyof EventPropertiesMap>(
    name: N,
    properties: TEventProperties<N>,
  ) => {
    posthog.capture(name, properties);
  };

  const dispatchGoogleAnalyticsEvent = <N extends keyof EventPropertiesMap>(
    _name: N,
    properties: TEventProperties<N>,
  ) => {
    window.dataLayer?.push(properties);
  };

  const dispatchEvent = <N extends keyof EventPropertiesMap>(
    event: N,
    properties: TEventProperties<N>,
  ) => {
    const currentUrl = window.location.href;
    const referrerUrl = document.referrer;

    const eventData = {
      ...properties,
      type: getEventType(event),
      page_location: currentUrl,
      page_referrer: referrerUrl,
    };

    dispatchPostHogEvent(event, eventData);
    dispatchGoogleAnalyticsEvent(event, eventData);
  };

  return {
    dispatchEvent,
  };
};
